import React from 'react'

const s = { 
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
};

const WaterSimulation = ({style, setCanvas, onClick}) => (
    <canvas style={{...s, ...style}} ref={setCanvas} onClick={onClick} />
);

export default WaterSimulation;



// WEBPACK FOOTER //
// ./src/modules/misc/WaterSimulation.js